module.exports = __webpack_public_path__ + "media/images/lb/548-f6764c75e4d5a8bbfb6089ff4b9a0fc8.svg";